/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, Slice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export interface IModalChildComponent {
  onClose: () => void;
  onCloseIcon?: () => void;
}
export interface IModalState<T extends IModalChildComponent> {
  open: boolean;
  ComponentProps: any | null;
  ComponentKeyName: string | null;
  id: string;
  Header?: React.ReactNode;
  Footer?: React.ReactNode;
  className?: string;
  title?: string;
  icon?: string;
}

export const initialState: IModalState<any> = {
  open: false,
  ComponentKeyName: null,
  ComponentProps: null,
  id: '',
};

export const modalSlice: Slice<IModalState<any>> = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModalState: (
      _,
      action: {
        payload: IModalState<any>;
      }
    ) => action.payload,
  },
});

export const { setModalState } = modalSlice.actions;

export const selectModal = (state: RootState) => state.modal;
